import FeedList, { FeedItem } from './FeedList';

export { FeedItem };
export default FeedList;
